
import React from "react";
import {IChannelComponents, IChannelComponentsWrapper} from "../interfaces";
import SearchFilter from "./search-filter";
import CheckIcon from "../../../../ui/svg/common/check-v";
import {useAppSelector} from "../../product-page/data-services/store";
import {ProductTypeEnum} from "../../product-page/data-services/data-service";


export interface IChannelComponentsProps {
    channelComponentsWrapper?:IChannelComponentsWrapper
}
/**
 * the entry point
 */
const TabChannelComponents = (props?: IChannelComponentsProps) => {

    const channelComponentsWrapper = props?.channelComponentsWrapper;
    const techSpecsSearchPlugins = useAppSelector((store) => store.techSpecsSearchPlugins);
    const productDataType = useAppSelector((store) => store.productDataType);
    const checkIcon =  <CheckIcon width="14" height="10" color="1D1D1D"  />

    const getSurroundComments = (item? : IChannelComponents) => {

        let resArr=[];
        if(item?.comps14)
            resArr.push(<li key="comps14">Mono<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Quad</li>);

        if(item?.comps15)
            resArr.push(<li key="comps15">Mono<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.0&nbsp;&nbsp;</li>);

        if(item?.comps16)
            resArr.push(<li key="comps16">Mono<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.1&nbsp;&nbsp;</li>);

        if(item?.comps24)
            resArr.push(<li key="comps24">Stereo<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Quad&nbsp;&nbsp;</li>);

        if(item?.comps25)
            resArr.push(<li key="comps25">Stereo<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.0&nbsp;&nbsp;</li>);

        if(item?.comps26)
            resArr.push(<li key="comps26">Stereo<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.1&nbsp;&nbsp;</li>);

        if(item?.comps28)
            resArr.push(<li key="comps28">Stereo<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>7.1&nbsp;&nbsp;</li>);

        if(item?.comps4)
            resArr.push(<li key="comps4">Quad&nbsp;&nbsp;</li>);

        if(item?.comps42)
            resArr.push(<li key="comps42">Quad<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Stereo&nbsp;&nbsp;</li>);

        if(item?.comps52)
            resArr.push(<li key="comps52">5.0<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Stereo&nbsp;&nbsp;</li>);

        if(item?.comps54)
            resArr.push(<li key="comps54">5.0<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Quad&nbsp;&nbsp;</li>);

        if(item?.comps55)
            resArr.push(<li key="comps55">5.0<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.0&nbsp;&nbsp;</li>);

        if(item?.comps56)
            resArr.push(<li key="comps56">5.0<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.1&nbsp;&nbsp;</li>);

        if(item?.comps62)
            resArr.push(<li key="comps62">5.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Stereo&nbsp;&nbsp;</li>);

        if(item?.comps64)
            resArr.push(<li key="comps64">5.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Quad&nbsp;&nbsp;</li>);

        if(item?.comps66)
            resArr.push( <li key="comps66">5.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.1&nbsp;&nbsp;</li>);

        if(item?.comps68)
            resArr.push( <li key="comps68">5.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>7.1&nbsp;&nbsp;</li>);

        if(item?.comps82)
            resArr.push( <li key="comps82">7.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Stereo&nbsp;&nbsp;</li>);

        if(item?.comps84)
            resArr.push( <li key="comps84">7.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Quad&nbsp;&nbsp;</li>);

        if(item?.comps86)
            resArr.push( <li key="comps86">7.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.1&nbsp;&nbsp;</li>);

        if(item?.comps88)
            resArr.push( <li key="comps88">7.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>7.1</li>);

        if(item?.compsAmbiXFuMa)
            resArr.push( <li key="compsAmbiXFuMa">AmbiX<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>FuMa&nbsp;&nbsp;</li>);

        if(item?.compsFuMaAmbiX)
            resArr.push( <li key="compsFuMaAmbiX">FuMa<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>AmbiX&nbsp;&nbsp;</li>);

        if(item?.chCompComment)
            resArr.push( <li key="chCompComment" className="pt-1"> <div className="w-full" dangerouslySetInnerHTML={{__html: item?.chCompComment}}/></li>);

        return resArr;
    };
    return (
        <div className="my-4">
            {channelComponentsWrapper != null && <div className={"my-4"} dangerouslySetInnerHTML={{ __html: channelComponentsWrapper?.topBanner }} />}
            {
                channelComponentsWrapper != null && channelComponentsWrapper.channelComponents.length > 0 &&
                <table className="table-fixed w-full text-base mt-8 rounded">
                    <thead style={{position:productDataType !== ProductTypeEnum.plugin ? "sticky" : "unset",top:(channelComponentsWrapper.topPosition && channelComponentsWrapper.topPosition !== null) ? channelComponentsWrapper.topPosition : "136px"}}>
                    {productDataType !== ProductTypeEnum.plugin &&  <tr>
                        <td className="bg-white" colSpan={10} >
                            <SearchFilter />
                        </td>
                    </tr>}
                    <tr className="h-20 bg-gray-150">
                        <td className="font-bold border pl-4">Name</td>
                        <td className="font-bold border text-center-webkit">Mono</td>
                        <td className="font-bold border text-center-webkit">Stereo</td>
                        <td className="font-bold border text-center-webkit">Mono-to-Stereo</td>
                        <td className="font-bold border text-center-webkit">Surround / Comments</td>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        channelComponentsWrapper?.channelComponents?.filter(s=>s.documentName.toLowerCase().includes(techSpecsSearchPlugins.toLowerCase())).map((cc, index) => {
                            return (
                                <tr key={ index }
                                    className="w-full h-20">
                                    <td className="border pl-4">{cc.documentName}</td>
                                    <td className="border text-center-webkit p-2">{cc.compsMono ? checkIcon : ""}</td>
                                    <td className="border text-center-webkit p-2">{cc.compsStereo ? checkIcon : ""}</td>
                                    <td className="border text-center-webkit p-2">{cc.compsMS ? checkIcon : ""}</td>
                                    <td className="border text-center-webkit p-2"><ul className="flex flex-wrap w-48">{getSurroundComments(cc)}</ul></td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            }
            {channelComponentsWrapper != null && <div className={"my-8"} dangerouslySetInnerHTML={{ __html: channelComponentsWrapper?.bottomBanner }} />}

        </div>
    )
};

export default TabChannelComponents;